module.exports = __webpack_public_path__ + "static/img/wr847bb.fcfd4b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/wr847bb.jpg
// module id = Z/7N
// module chunks = 0